import {useEffect, useState} from 'react'
import axios from 'axios'
import {
  Box,
  Typography,
  Button,
  Tabs,
  Tab,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import {toast} from 'react-toastify'
import {useHistory, useParams} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import dayjs from 'dayjs'
import {MoonLoader} from 'react-spinners'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {AppDispatch} from '../../../../../setup/redux/Store'
import {
  NEW_NURSES_ASSESSMENT_INPUTS,
  NEW_NURSES_ASSESSMENT_FORM_INPUTS,
  NURSES_ASSESSMENT_FORM1_INITIAL_STATE,
  NURSES_ASSESSMENT_FORM2_INITIAL_STATE,
  NURSES_ASSESSMENT_FORM3_INITIAL_STATE,
  NURSES_ASSESSMENT_FORM4_INITIAL_STATE,
  NursesAssessmentForm1Fields,
  NursesAssessmentForm2Fields,
  NursesAssessmentForm3Fields,
  NursesAssessmentForm4Fields,
} from '../GENERAL_CONSTANTS'
import {RootState} from '../../../../../setup'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import NursesAssessmentform1 from './NursesAssessmentForms/NursesAssessmentForm1'
import NursesAssessmentForm2 from './NursesAssessmentForms/NursesAssessmentForm2'
import NursesAssessmentForm3 from './NursesAssessmentForms/NursesAssessmentForm3'
import NursesAssessmentForm4 from './NursesAssessmentForms/NursesAssessmentForm4'
import DescriptionModal from '../../../../reusable-components/description-modal/descriptionmodal'
import NavigateButton from '../../../../reusable-components/description-modal/navigatebutton'
import AssessmentTypeSelect from '../../../../reusable-components/AssesmentType/AssesmentType'
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nurses-assessment-tabpanel-${index}`}
      aria-labelledby={`nurses-assessment-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `nurses-assessment-tab-${index}`,
    'aria-controls': `nurses-assessment-tabpanel-${index}`,
  }
}

export default function EditNursesAssessmentNote() {
  const history = useHistory()
  const [isFormLoading, setIsFormLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [isMobile, setIsMobile] = useState(false)
  const [formElements, setFormElements] = useState([])
  const params: {id: string} = useParams()
  const [clients, setClients] = useState([])
  const [uiElementsList, setUiElementsList] = useState([])

    const [isModalOpen, setIsModalOpen] = useState(false)
  const [description, setDescription] = useState('')
  const [pendingSubmit, setPendingSubmit] = useState(false)
  const [submittedFormData, setSubmittedFormData] = useState(null)
  const [clientId, setClientId] = useState(null) 

  // Separate form data states
  const [formData, setFormData] = useState(NEW_NURSES_ASSESSMENT_FORM_INPUTS)
  const [form1Data, setForm1Data] = useState<NursesAssessmentForm1Fields>(
    NURSES_ASSESSMENT_FORM1_INITIAL_STATE
  )
  const [form2Data, setForm2Data] = useState<NursesAssessmentForm2Fields>(
    NURSES_ASSESSMENT_FORM2_INITIAL_STATE
  )
  const [form3Data, setForm3Data] = useState<NursesAssessmentForm3Fields>(
    NURSES_ASSESSMENT_FORM3_INITIAL_STATE
  )
  const [form4Data, setForm4Data] = useState<NursesAssessmentForm4Fields>(
    NURSES_ASSESSMENT_FORM4_INITIAL_STATE
  )
  const [noteData, setNoteData] = useState({
    noteType: '',
    assessmentType: '', 
  })

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 900)
    }
    
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  useEffect(() => {
    setFormElements(NEW_NURSES_ASSESSMENT_INPUTS)
    fetchData()
  }, [])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  const fetchData = async () => {
    setIsFormLoading(true)
    try {
      const res = await axios.get(`/nursesAssessment/getById/${params.id}`)
      const data = res.data.result

      const response = await axios.get('/clients/getClientNames')
      const {data: clientsList} = response?.data

      const updatedClients = clientsList.map((client) => ({
        label: client.fullName,
        value: client._id,
      }))

      setClientId(data.clientId)

      // Set note data
      setNoteData({
        noteType: data.noteType,
        assessmentType: data.assessmentType || '',
      })

      // Map data to form1 (General Information)
      const form1MappedData = {
        clientId: data.clientId,
        assessmentDate: data.generalInformation?.assessmentDate,
        allergies: data.generalInformation?.allergies || [],
        otherAllergies: data.generalInformation?.otherAllergies,
        codeStatus: data.generalInformation?.codeStatus,
        infoSource: data.generalInformation?.infoSource,
        otherInfoSource: data.generalInformation?.otherInfoSource,
        precautions: data.generalInformation?.precautions,
        otherPrecautions: data.generalInformation?.otherPrecautions,
        t: data.generalInformation?.vitalSigns?.t,
        p: data.generalInformation?.vitalSigns?.p,
        bp: data.generalInformation?.vitalSigns?.bp,
        r: data.generalInformation?.vitalSigns?.r,
        weight: data.generalInformation?.vitalSigns?.weight,
        height: data.generalInformation?.vitalSigns?.height,
        medications: data.medications || [],
        wounds: data.dietaryScreen?.wounds,
        alternativeNutrition: data.dietaryScreen?.alternativeNutrition,
        weightdetails: data.dietaryScreen?.weightdetails,
        weightamount: data.dietaryScreen?.weightamount,
        dietaryDetails: data.dietaryScreen?.dietaryDetails || [],
      }

      // Map data to form2 (Psychosocial & Medical)
      const form2MappedData = {
        leisureInterest: data.psychosicial?.leisureInterest || [],
        socialActivities: data.psychosicial?.socialActivities,
        copingSkills: data.psychosicial?.copingSkills,
        culturalPractices: data.psychosicial?.culturalPractices,
        spiritualPractices: data.psychosicial?.spiritualPractices,
        otherPsychosocial: data.psychosicial?.otherPsychosocial,
        abuseHistory: data.psychosicial?.abuseHistory,
        selfHarm: data.psychosicial?.selfHarm,
        etohConsumption: data.psychosicial?.etohConsumption,
        drugAbuse: data.psychosicial?.drugAbuse,
        caffeineIntake: data.psychosicial?.caffeineIntake,
        tobaccoUse: data.psychosicial?.tobaccoUse,
        cessationEducation: data.psychosicial?.cessationEducation,
        medicalHistory: data.medicalDetails?.medicalHistory || [],
        lastFluVaccine: data.medicalDetails?.lastFluVaccine,
        lastPneumoniaVaccine: data.medicalDetails?.lastPneumoniaVaccine,
        prevSurgeries: data.medicalDetails?.prevSurgeries,
        prevSurgeriesDetails: data.medicalDetails?.prevSurgeriesDetails,
        followingSymptoms: data.medicalDetails?.followingSymptoms,
        transfusionReactionDetails: data.medicalDetails?.transfusionReactionDetails,
        diabeticYears: data.medicalDetails?.diabeticYears,
        diabeticTreatment: data.medicalDetails?.diabeticTreatment,
        preferredLanguage: data.medicalDetails?.preferredLanguage,
        familyCareInvolved: data.medicalDetails?.familyCareInvolved,
        educationalNeeds: data.medicalDetails?.educationalNeeds,
        patientTB: data.medicalDetails?.patientTB,
        familyTB: data.medicalDetails?.familyTB,
        bloodTransfusion: data.medicalDetails?.bloodTransfusion,
        diabetic: data.medicalDetails?.diabetic,
        glucometer: data.medicalDetails?.glucometer,
        fingerStick: data.medicalDetails?.fingerStick,
        administerInsulin: data.medicalDetails?.administerInsulin,
        interpreterNeeded: data.medicalDetails?.interpreterNeeded,
        familyAvailforTeaching: data.medicalDetails?.familyAvailforTeaching,
        response: data.neurologic?.response,
        motorResponse: data.neurologic?.motorResponse,
        verbalResponse: data.neurologic?.verbalResponse,
        affect: data.neurologic?.affect,
        otherAffect: data.neurologic?.otherAffect,
        hearing: data.neurologic?.hearing,
        vision: data.neurologic?.vision,
        gagReflex: data.neurologic?.gagReflex,
        speech: data.neurologic?.speech,
      }

      // Map data to form3 (Cardiovascular & Pulmonary)
      const form3MappedData = {
        regular: data.cardiovascular?.regular || [],
        irregular: data.cardiovascular?.irregular || [],
        strong: data.cardiovascular?.strong || [],
        weak: data.cardiovascular?.weak || [],
        chestPain: data.cardiovascular?.chestPain,
        chestPainLoc: data.cardiovascular?.chestPainLoc,
        nailBeds: data.cardiovascular?.nailBeds,
        edemafour: data.cardiovascular?.edemafour || [],
        edemafourDetails: data.cardiovascular?.edemafourDetails,
        edemathree: data.cardiovascular?.edemathree || [],
        edemathreeDetails: data.cardiovascular?.edemathreeDetails,
        edematwo: data.cardiovascular?.edematwo || [],
        edematwoDetails: data.cardiovascular?.edematwoDetails,
        edemaone: data.cardiovascular?.edemaone || [],
        edemaoneDetails: data.cardiovascular?.edemaoneDetails,
        capillaryRefillOtherDetails: data.cardiovascular?.capillaryRefillOtherDetails,
        capillaryRefillTime: data.cardiovascular?.capillaryRefillTime,
        otherCardiovascular: data.cardiovascular?.otherCardiovascular || [],
        cardianRhythmDetails: data.cardiovascular?.cardianRhythmDetails,
        clear: data.pulmonary?.clear || [],
        equalbilaterally: data.pulmonary?.equalbilaterally || [],
        course: data.pulmonary?.course || [],
        rales: data.pulmonary?.rales || [],
        rhonchi: data.pulmonary?.rhonchi || [],
        wheeze: data.pulmonary?.wheeze || [],
        pleural: data.pulmonary?.pleural || [],
        otherSoundDetails: data.pulmonary?.otherSoundDetails,
        cough: data.pulmonary?.cough,
        coughColor: data.pulmonary?.coughColor,
        coughQuality: data.pulmonary?.coughQuality,
        coughQuantity: data.pulmonary?.coughQuantity,
        nasalFlaring: data.pulmonary?.nasalFlaring,
        breathShortness: data.pulmonary?.breathShortness,
        ett: data.pulmonary?.ett,
        ettSize: data.pulmonary?.ettSize,
        o2: data.pulmonary?.o2,
        o2Amount: data.pulmonary?.o2Amount,
        o2Size: data.pulmonary?.o2Size,
        o2TakenVia: data.pulmonary?.o2TakenVia,
        edemanone: data.cardiovascular?.edemanone,
        otherPulmonary: data.pulmonary?.otherPulmonary,
        takenvia: data.pulmonary?.o2TakenVia,
      }

      // Map data to form4 (GI, GU & Musculoskeletal)
      const form4MappedData = {
        lastBMdate: data.gastroIntestinal?.lastBMdate,
        bowelPatterns: data.gastroIntestinal?.bowelPatterns,
        bowelSounds: data.gastroIntestinal?.bowelSounds,
        abdomen: data.gastroIntestinal?.abdomen,
        abdomenLocation: data.gastroIntestinal?.abdomenLocation,
        experiencingGI: data.genitourinary?.experiencingGI,
        urineColor: data.genitourinary?.urineColor,
        bladder: data.genitourinary?.bladder,
        catheterType: data.genitourinary?.catheterType,
        catheterSize: data.genitourinary?.catheterSize,
        catheterDate: data.genitourinary?.catheterDate,
        catheterChange: data.genitourinary?.catheterChange,
        equal: data.musculoskeletal?.muscleStrength?.muscleEqual || [],
        strong: data.musculoskeletal?.muscleStrength?.muscleStrong || [],
        weak: data.musculoskeletal?.muscleStrength?.muscleWeak || [],
        paralysis: data.musculoskeletal?.muscleStrength?.paralysis || [],
        spastic: data.musculoskeletal?.muscleStrength?.spastic || [],
        contracture: data.musculoskeletal?.muscleStrength?.contracture || [],
        flaccid: data.musculoskeletal?.muscleStrength?.flaccid || [],
        amputation: data.musculoskeletal?.muscleStrength?.amputation || [],
        bedMobility: data.musculoskeletal?.physicalImpaired?.bedMobility,
        transfers: data.musculoskeletal?.physicalImpaired?.transfers,
        gait: data.musculoskeletal?.physicalImpaired?.gait,
        balance: data.musculoskeletal?.physicalImpaired?.balance,
        comprehension: data.musculoskeletal?.communicationFunction?.comprehension,
        expression: data.musculoskeletal?.communicationFunction?.expression,
        cognition: data.musculoskeletal?.communicationFunction?.cognition,
        readingWriting: data.musculoskeletal?.communicationFunction?.readingWriting,
        grooming: data.musculoskeletal?.adlFunction?.grooming,
        feeding: data.musculoskeletal?.adlFunction?.feeding,
        bathing: data.musculoskeletal?.adlFunction?.bathing,
        dressing: data.musculoskeletal?.adlFunction?.dressing,
        assistiveDevices: data.musculoskeletal?.assistiveDevices || [],
        otherassistiveDevices: data.musculoskeletal?.otherassistiveDevices,
        skinColor: data.skinAssessment?.skinColor || [],
        otherskinDetails: data.skinAssessment?.otherskinDetails,
        skintempreture: data.skinAssessment?.skintempreture || [],
        otherskinTempDetails: data.skinAssessment?.otherskinTempDetails,
        turgor: data.skinAssessment?.turgor,
        otherTurgorDetails: data.skinAssessment?.otherTurgorDetails,
        skinTexture: data.skinAssessment?.skinTexture,
        otherskinTextureDetails: data.skinAssessment?.otherskinTextureDetails,
        sensory: data.skinAssessment?.bradenScale?.sensory,
        moisture: data.skinAssessment?.bradenScale?.moisture,
        activity: data.skinAssessment?.bradenScale?.activity,
        mobility: data.skinAssessment?.bradenScale?.mobility,
        nutrition: data.skinAssessment?.bradenScale?.nutrition,
        friction: data.skinAssessment?.bradenScale?.friction,
        skinPrecatuions: data.skinAssessment?.skinPrecatuions,
        woundTeamNotified: data.skinAssessment?.woundTeamNotified,
        diet: data.nutrition?.diet,
        dietType: data.nutrition?.dietType,
        supplements: data.nutrition?.supplements,
        howOften: data.nutrition?.howOften,
        restricitons: data.nutrition?.restricitons,
        appetite: data.nutrition?.appetite,
        tubeFeeding: data.nutrition?.tubeFeeding,
        parentalFeeding: data.nutrition?.parentalFeeding,
        experiencing: data.nutrition?.experiencing || [],
        mucosaIntact: data.nutrition?.mucosaIntact,
        tongueIntact: data.nutrition?.tongueIntact,
        dentitionIntact: data.nutrition?.dentitionIntact,
        otherdetails: data.nutrition?.otherdetails,
        communicationFunction: data.musculoskeletal?.communicationFunction || [],
        adlFunction: data.musculoskeletal?.adlFunction || [],
      }

      const transformedPainAssessment = (data.painAsessment || []).map((pain: any) => ({
        location: pain.location || '',
        rating: pain.rating || '',
        onset: pain.onset || '',
        reliefMeasures: pain.reliefMeasures || '',
        otherDetails: pain.reliefMeasuresDetails || pain.otherDetails || '',
      }))

      const additionalFormData = {
        painAsessment: transformedPainAssessment,
        painScale: data.painScale,
        fallWithinYear: data.fallRisk?.fallWithinYear || '',
        currentlyonFallPrecaution: data.fallRisk?.currentlyonFallPrecaution || '',
        vascularAcess: data.vascularAcess || [],
      }

      setForm1Data(form1MappedData)
      setForm2Data(form2MappedData)
      setForm3Data(form3MappedData)
      setForm4Data(form4MappedData)
      setFormData(additionalFormData)

      const baseForm = NEW_NURSES_ASSESSMENT_INPUTS.map((item) => {
        if (item.name === 'clientId') {
          return {
            ...item,
            options: updatedClients,
            disabled: true,
            value: data.clientId,
          }
        }
        return item
      })

      setUiElementsList(baseForm)
      setClients(updatedClients)
    } catch (error) {
      console.error('Error fetching data:', error)
      toast.error('Failed to fetch assessment data')
    } finally {
      setIsFormLoading(false)
    }
  }
  const handleSaveDescription = (desc) => {
    setDescription(desc)
    setIsModalOpen(false)
    setPendingSubmit(false)
  
    if (submittedFormData) {
      handleSubmitForm(submittedFormData)
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setPendingSubmit(false)
    setSubmittedFormData(null)
  }
  const handleSubmitForm = async (currentFormData) => {
    if (!description.trim() && !isModalOpen) {
      const combinedFormData = {
        ...formData,
        form1Data,
        form2Data,
        form3Data,
        form4Data,
        ...(currentFormData || {})
      }
      
      setSubmittedFormData(combinedFormData) 
      setIsModalOpen(true)
      setPendingSubmit(true)
      return
    }

    const formPayload = submittedFormData || {
      ...formData,
      form1Data,
      form2Data,
      form3Data,
      form4Data,
      ...(currentFormData || {})
    }

    const noteId = params.id
    setIsFormLoading(true)
    try {
      // Build payload with explicit hierarchy, mapping all fields
      const payload = {
        clientId: formPayload.form1Data?.clientId || form1Data.clientId,
        noteType: noteData.noteType,
        assessmentType: noteData.assessmentType || '',
        generalInformation: {
          assessmentDate: formPayload.form1Data?.assessmentDate || form1Data.assessmentDate,
          allergies: Array.isArray(formPayload.form1Data?.allergies || form1Data.allergies) ? [...(formPayload.form1Data?.allergies || form1Data.allergies)] : [],
          otherAllergies: formPayload.form1Data?.otherAllergies || form1Data.otherAllergies,
          codeStatus: formPayload.form1Data?.codeStatus || form1Data.codeStatus,
          infoSource: formPayload.form1Data?.infoSource || form1Data.infoSource,
          otherInfoSource: formPayload.form1Data?.otherInfoSource || form1Data.otherInfoSource,
          precautions: formPayload.form1Data?.precautions || form1Data.precautions,
          otherPrecautions: formPayload.form1Data?.otherPrecautions || form1Data.otherPrecautions,
          vitalSigns: {
            t: formPayload.form1Data?.t || form1Data.t || '',
            r: formPayload.form1Data?.r || form1Data.r || '',
            p: formPayload.form1Data?.p || form1Data.p || '',
            bp: formPayload.form1Data?.bp || form1Data.bp || '',
            height: formPayload.form1Data?.height || form1Data.height || '',
            weight: formPayload.form1Data?.weight || form1Data.weight || ''
          },
        },
        medications: Array.isArray(formPayload.form1Data?.medications || form1Data.medications) ? [...(formPayload.form1Data?.medications || form1Data.medications)] : [],
        dietaryScreen: {
          wounds: formPayload.form1Data?.wounds || form1Data.wounds,
          alternativeNutrition: formPayload.form1Data?.alternativeNutrition || form1Data.alternativeNutrition,
          weightdetails: formPayload.form1Data?.weightdetails || form1Data.weightdetails,
          weightamount: formPayload.form1Data?.weightamount || form1Data.weightamount,
          dietaryDetails: Array.isArray(formPayload.form1Data?.dietaryDetails || form1Data.dietaryDetails)
            ? [...(formPayload.form1Data?.dietaryDetails || form1Data.dietaryDetails)]
            : [],
        },
        psychosicial: {
          leisureInterest: Array.isArray(formPayload.form2Data?.leisureInterest || form2Data.leisureInterest)
            ? [...(formPayload.form2Data?.leisureInterest || form2Data.leisureInterest)]
            : [],
          socialActivities: formPayload.form2Data?.socialActivities || form2Data.socialActivities,
          copingSkills: formPayload.form2Data?.copingSkills || form2Data.copingSkills,
          culturalPractices: formPayload.form2Data?.culturalPractices || form2Data.culturalPractices,
          spiritualPractices: formPayload.form2Data?.spiritualPractices || form2Data.spiritualPractices,
          otherPsychosocial: formPayload.form2Data?.otherPsychosocial || form2Data.otherPsychosocial,
          abuseHistory: formPayload.form2Data?.abuseHistory || form2Data.abuseHistory,
          selfHarm: formPayload.form2Data?.selfHarm || form2Data.selfHarm,
          etohConsumption: formPayload.form2Data?.etohConsumption || form2Data.etohConsumption,
          drugAbuse: formPayload.form2Data?.drugAbuse || form2Data.drugAbuse,
          caffeineIntake: formPayload.form2Data?.caffeineIntake || form2Data.caffeineIntake,
          tobaccoUse: formPayload.form2Data?.tobaccoUse || form2Data.tobaccoUse,
          cessationEducation: formPayload.form2Data?.cessationEducation || form2Data.cessationEducation,
        },
        medicalDetails: {
          medicalHistory: Array.isArray(formPayload.form2Data?.medicalHistory || form2Data.medicalHistory)
            ? [...(formPayload.form2Data?.medicalHistory || form2Data.medicalHistory)]
            : [],
          lastFluVaccine: formPayload.form2Data?.lastFluVaccine || form2Data.lastFluVaccine,
          lastPneumoniaVaccine: formPayload.form2Data?.lastPneumoniaVaccine || form2Data.lastPneumoniaVaccine,
          prevSurgeries: formPayload.form2Data?.prevSurgeries || form2Data.prevSurgeries,
          patientTB: formPayload.form2Data?.patientTB || form2Data.patientTB,
          familyTB: formPayload.form2Data?.familyTB || form2Data.familyTB,
          followingSymptoms: formPayload.form2Data?.followingSymptoms || form2Data.followingSymptoms,
          bloodTransfusion: formPayload.form2Data?.bloodTransfusion || form2Data.bloodTransfusion,
          transfusionReactionDetails: formPayload.form2Data?.transfusionReactionDetails || form2Data.transfusionReactionDetails,
          diabetic: formPayload.form2Data?.diabetic || form2Data.diabetic,
          diabeticYears: formPayload.form2Data?.diabeticYears || form2Data.diabeticYears,
          diabeticTreatment: formPayload.form2Data?.diabeticTreatment || form2Data.diabeticTreatment,
          glucometer: formPayload.form2Data?.glucometer || form2Data.glucometer,
          fingerStick: formPayload.form2Data?.fingerStick || form2Data.fingerStick,
          administerInsulin: formPayload.form2Data?.administerInsulin || form2Data.administerInsulin,
          interpreterNeeded: formPayload.form2Data?.interpreterNeeded || form2Data.interpreterNeeded,
          preferredLanguage: formPayload.form2Data?.preferredLanguage || form2Data.preferredLanguage,
          familyCareInvolved: formPayload.form2Data?.familyCareInvolved || form2Data.familyCareInvolved,
          familyAvailforTeaching: formPayload.form2Data?.familyAvailforTeaching || form2Data.familyAvailforTeaching,
          educationalNeeds: formPayload.form2Data?.educationalNeeds || form2Data.educationalNeeds,
          prevSurgeriesDetails: formPayload.form2Data?.prevSurgeriesDetails || form2Data.prevSurgeriesDetails,
        },
        neurologic: {
          response: formPayload.form2Data?.response || form2Data.response,
          motorResponse: formPayload.form2Data?.motorResponse || form2Data.motorResponse,
          verbalResponse: formPayload.form2Data?.verbalResponse || form2Data.verbalResponse,
          affect: formPayload.form2Data?.affect || form2Data.affect,
          otherAffect: formPayload.form2Data?.otherAffect || form2Data.otherAffect,
          hearing: formPayload.form2Data?.hearing || form2Data.hearing,
          vision: formPayload.form2Data?.vision || form2Data.vision,
          gagReflex: formPayload.form2Data?.gagReflex || form2Data.gagReflex,
          speech: formPayload.form2Data?.speech || form2Data.speech,
        },
        cardiovascular: {
          regular: Array.isArray(formPayload.form3Data?.regular || form3Data.regular) ? [...(formPayload.form3Data?.regular || form3Data.regular)] : [],
          irregular: Array.isArray(formPayload.form3Data?.irregular || form3Data.irregular) ? [...(formPayload.form3Data?.irregular || form3Data.irregular)] : [],
          strong: Array.isArray(formPayload.form3Data?.strong || form3Data.strong) ? [...(formPayload.form3Data?.strong || form3Data.strong)] : [],
          weak: Array.isArray(formPayload.form3Data?.weak || form3Data.weak) ? [...(formPayload.form3Data?.weak || form3Data.weak)] : [],
          chestPain: formPayload.form3Data?.chestPain || form3Data.chestPain,
          chestPainLoc: formPayload.form3Data?.chestPainLoc || form3Data.chestPainLoc,
          nailBeds: formPayload.form3Data?.nailBeds || form3Data.nailBeds,
          edemafour: Array.isArray(formPayload.form3Data?.edemafour || form3Data.edemafour) ? [...(formPayload.form3Data?.edemafour || form3Data.edemafour)] : [],
          edemafourDetails: formPayload.form3Data?.edemafourDetails || form3Data.edemafourDetails,
          edemathree: Array.isArray(formPayload.form3Data?.edemathree || form3Data.edemathree) ? [...(formPayload.form3Data?.edemathree || form3Data.edemathree)] : [],
          edemathreeDetails: formPayload.form3Data?.edemathreeDetails || form3Data.edemathreeDetails,
          edematwo: Array.isArray(formPayload.form3Data?.edematwo || form3Data.edematwo) ? [...(formPayload.form3Data?.edematwo || form3Data.edematwo)] : [],
          edematwoDetails: formPayload.form3Data?.edematwoDetails || form3Data.edematwoDetails,
          edemaone: Array.isArray(formPayload.form3Data?.edemaone || form3Data.edemaone) ? [...(formPayload.form3Data?.edemaone || form3Data.edemaone)] : [],
          edemaoneDetails: formPayload.form3Data?.edemaoneDetails || form3Data.edemaoneDetails,
          otherCardiovascular: formPayload.form3Data?.otherCardiovascular || form3Data.otherCardiovascular,
          cardianRhythmDetails: formPayload.form3Data?.cardianRhythmDetails || form3Data.cardianRhythmDetails,
          edemanone: formPayload.form3Data?.edemanone || form3Data.edemanone,
          capillaryRefillOtherDetails: formPayload.form3Data?.capillaryRefillOtherDetails || form3Data.capillaryRefillOtherDetails,
          capillaryRefillTime: formPayload.form3Data?.capillaryRefillTime || form3Data.capillaryRefillTime,
        },
        pulmonary: {
          clear: Array.isArray(formPayload.form3Data?.clear || form3Data.clear) ? [...(formPayload.form3Data?.clear || form3Data.clear)] : [],
          equalbilaterally: Array.isArray(formPayload.form3Data?.equalbilaterally || form3Data.equalbilaterally)
            ? [...(formPayload.form3Data?.equalbilaterally || form3Data.equalbilaterally)]
            : [],
          course: Array.isArray(formPayload.form3Data?.course || form3Data.course) ? [...(formPayload.form3Data?.course || form3Data.course)] : [],
          rales: Array.isArray(formPayload.form3Data?.rales || form3Data.rales) ? [...(formPayload.form3Data?.rales || form3Data.rales)] : [],
          rhonchi: Array.isArray(formPayload.form3Data?.rhonchi || form3Data.rhonchi) ? [...(formPayload.form3Data?.rhonchi || form3Data.rhonchi)] : [],
          wheeze: Array.isArray(formPayload.form3Data?.wheeze || form3Data.wheeze) ? [...(formPayload.form3Data?.wheeze || form3Data.wheeze)] : [],
          pleural: Array.isArray(formPayload.form3Data?.pleural || form3Data.pleural) ? [...(formPayload.form3Data?.pleural || form3Data.pleural)] : [],
          otherSoundDetails: formPayload.form3Data?.otherSoundDetails || form3Data.otherSoundDetails,
          cough: formPayload.form3Data?.cough || form3Data.cough,
          coughColor: formPayload.form3Data?.coughColor || form3Data.coughColor,
          coughQuality: formPayload.form3Data?.coughQuality || form3Data.coughQuality,
          coughQuantity: formPayload.form3Data?.coughQuantity || form3Data.coughQuantity,
          nasalFlaring: formPayload.form3Data?.nasalFlaring || form3Data.nasalFlaring,
          ett: formPayload.form3Data?.ett || form3Data.ett,
          o2: formPayload.form3Data?.o2 || form3Data.o2,
          breathShortness: formPayload.form3Data?.breathShortness || form3Data.breathShortness,
          ettSize: formPayload.form3Data?.ettSize || form3Data.ettSize,
          o2Amount: formPayload.form3Data?.o2Amount || form3Data.o2Amount,
          o2TakenVia: formPayload.form3Data?.o2TakenVia || form3Data.o2TakenVia,
        },
        gastroIntestinal: {
          lastBMdate: formPayload.form4Data?.lastBMdate || form4Data.lastBMdate,
          bowelPatterns: formPayload.form4Data?.bowelPatterns || form4Data.bowelPatterns,
          bowelSounds: formPayload.form4Data?.bowelSounds || form4Data.bowelSounds,
          abdomen: formPayload.form4Data?.abdomen || form4Data.abdomen,
          abdomenLocation: formPayload.form4Data?.abdomenLocation || form4Data.abdomenLocation,
        },
        genitourinary: {
          experiencingGI: formPayload.form4Data?.experiencingGI || form4Data.experiencingGI,
          urineColor: formPayload.form4Data?.urineColor || form4Data.urineColor,
          bladder: formPayload.form4Data?.bladder || form4Data.bladder,
          catheterType: formPayload.form4Data?.catheterType || form4Data.catheterType,
          catheterSize: formPayload.form4Data?.catheterSize || form4Data.catheterSize,
          catheterDate: formPayload.form4Data?.catheterDate || form4Data.catheterDate,
          catheterChange: formPayload.form4Data?.catheterChange || form4Data.catheterChange,
        },
        musculoskeletal: {
          muscleStrength: {
            muscleEqual: Array.isArray(formPayload.form4Data?.equal || form4Data.equal) ? [...(formPayload.form4Data?.equal || form4Data.equal)] : [],
            muscleStrong: Array.isArray(formPayload.form4Data?.strong || form4Data.strong) ? [...(formPayload.form4Data?.strong || form4Data.strong)] : [],
            muscleWeak: Array.isArray(formPayload.form4Data?.weak || form4Data.weak) ? [...(formPayload.form4Data?.weak || form4Data.weak)] : [],
            paralysis: Array.isArray(formPayload.form4Data?.paralysis || form4Data.paralysis) ? [...(formPayload.form4Data?.paralysis || form4Data.paralysis)] : [],
            spastic: Array.isArray(formPayload.form4Data?.spastic || form4Data.spastic) ? [...(formPayload.form4Data?.spastic || form4Data.spastic)] : [],
            contracture: Array.isArray(formPayload.form4Data?.contracture || form4Data.contracture) ? [...(formPayload.form4Data?.contracture || form4Data.contracture)] : [],
            flaccid: Array.isArray(formPayload.form4Data?.flaccid || form4Data.flaccid) ? [...(formPayload.form4Data?.flaccid || form4Data.flaccid)] : [],
            amputation: Array.isArray(formPayload.form4Data?.amputation || form4Data.amputation) ? [...(formPayload.form4Data?.amputation || form4Data.amputation)] : [],
          },
          physicalImpaired: {
            bedMobility: formPayload.form4Data?.bedMobility || form4Data.bedMobility || false,
            transfers: formPayload.form4Data?.transfers || form4Data.transfers || false,
            gait: formPayload.form4Data?.gait || form4Data.gait || false,
            balance: formPayload.form4Data?.balance || form4Data.balance || false,
          },
          communicationFunction: {
            comprehension: formPayload.form4Data?.comprehension || form4Data.comprehension || false,
            expression: formPayload.form4Data?.expression || form4Data.expression || false,
            cognition: formPayload.form4Data?.cognition || form4Data.cognition || false,
            readingWriting: formPayload.form4Data?.readingWriting || form4Data.readingWriting || false,
          },
          adlFunction: {
            grooming: formPayload.form4Data?.grooming || form4Data.grooming || false,
            feeding: formPayload.form4Data?.feeding || form4Data.feeding || false,
            bathing: formPayload.form4Data?.bathing || form4Data.bathing || false,
            dressing: formPayload.form4Data?.dressing || form4Data.dressing || false,
          },
          assistiveDevices: Array.isArray(formPayload.form4Data?.assistiveDevices || form4Data.assistiveDevices) ? [...(formPayload.form4Data?.assistiveDevices || form4Data.assistiveDevices)] : [],
          otherassistiveDevices: formPayload.form4Data?.otherassistiveDevices || form4Data.otherassistiveDevices,
        },
        skinAssessment: {
          skinColor: Array.isArray(formPayload.form4Data?.skinColor || form4Data.skinColor) ? [...(formPayload.form4Data?.skinColor || form4Data.skinColor)] : [],
          otherskinDetails: formPayload.form4Data?.otherskinDetails || form4Data.otherskinDetails,
          otherskinTempDetails: formPayload.form4Data?.otherskinTempDetails || form4Data.otherskinTempDetails,
          otherTurgorDetails: formPayload.form4Data?.otherTurgorDetails || form4Data.otherTurgorDetails,
          otherskinTextureDetails: formPayload.form4Data?.otherskinTextureDetails || form4Data.otherskinTextureDetails,
          bradenScale: {
            sensory: formPayload.form4Data?.sensory || form4Data.sensory,
            moisture: formPayload.form4Data?.moisture || form4Data.moisture,
            activity: formPayload.form4Data?.activity || form4Data.activity,
            mobility: formPayload.form4Data?.mobility || form4Data.mobility,
            nutrition: formPayload.form4Data?.nutrition || form4Data.nutrition,
            friction: formPayload.form4Data?.friction || form4Data.friction,
          },
          skinPrecatuions: formPayload.form4Data?.skinPrecatuions || form4Data.skinPrecatuions || false,
          woundTeamNotified: formPayload.form4Data?.woundTeamNotified || form4Data.woundTeamNotified || false,
        },
        nutrition: {
          dietType: formPayload.form4Data?.dietType || form4Data.dietType,
          supplements: formPayload.form4Data?.supplements || form4Data.supplements,
          howOften: formPayload.form4Data?.howOften || form4Data.howOften,
          restricitons: formPayload.form4Data?.restricitons || form4Data.restricitons,
          parentalFeeding: formPayload.form4Data?.parentalFeeding || form4Data.parentalFeeding,
          experiencing: formPayload.form4Data?.experiencing || form4Data.experiencing || [],
          mucosaIntact: formPayload.form4Data?.mucosaIntact || form4Data.mucosaIntact || false,
          tongueIntact: formPayload.form4Data?.tongueIntact || form4Data.tongueIntact || false,
          dentitionIntact: formPayload.form4Data?.dentitionIntact || form4Data.dentitionIntact || false,
          otherdetails: formPayload.form4Data?.otherdetails || form4Data.otherdetails,
        },
        painAsessment: Array.isArray(formPayload.painAsessment || formData.painAsessment) 
          ? (formPayload.painAsessment || formData.painAsessment).map((pain: any) => ({
              location: pain.location || '',
              rating: pain.rating || '',
              onset: pain.onset|| '',
              reliefMeasures: pain.reliefMeasures || '',
              reliefMeasuresDetails: pain.otherDetails || '',
            }))
          : [],
        painScale: formPayload.painScale || formData.painScale,
        fallRisk: {
          fallWithinYear: formPayload.fallWithinYear || formData.fallWithinYear || '',
          currentlyonFallPrecaution: formPayload.currentlyonFallPrecaution || formData.currentlyonFallPrecaution || '',
        },
        vascularAcess: Array.isArray(formPayload.vascularAcess || formData.vascularAcess) ? [...(formPayload.vascularAcess || formData.vascularAcess)] : [],
        description: description,
      }

      const res = await axios.put(`/nursesAssessment/update/${noteId}`, payload)

      const {message, success} = res?.data
      if (!success) {
        return toast.error(message)
      }

      toast.success(message)
      history.push('/notes/nurses-notes/list')
    } catch (e) {
      toast.error(e?.response?.data?.error || `Couldn't Update Note`)
      console.error('Error updating note:', e)
    } finally {
      setIsFormLoading(false)
      setSubmittedFormData(null)
    }
  }

  const handleSaveAll = () => {
    // Combine all form data and submit
    const combinedFormData = {
      ...formData,
      form1Data,
      form2Data,
      form3Data,
      form4Data,
    }
    handleSubmitForm(combinedFormData)
  }

  const handleNext = () => {
    if (activeTab < 4) {
      setActiveTab(activeTab + 1)
    }
  }

  const handlePrevious = () => {
    if (activeTab > 0) {
      setActiveTab(activeTab - 1)
    }
  }
  return (
    <>
    <FormWrapper
      title='Nursing Assessment'
      content={
        <>
          
          {isFormLoading ? (
            <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
              <MoonLoader color='#9db2fc' size={60} loading={isFormLoading} />
            </div>
          ) : (     
            <>
            <Box sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0.5rem',
            gap: '0.5rem'
          }}>
            <NavigateButton
              label='View Edit History'
              clientId={clientId}
              section='NURSES_ASSESSMENT_SECTION'
            />
            
          </Box>
            <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '0.5rem',
              marginLeft: '1rem',
            }}
            color='primary'
          >
            Note Type
          </Typography>
          <Box sx={{ px: 2, mb: 2 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6}>
                          <FrequencyDateRangePicker
                            isEntry={false}
                            isTemplate={true}
                            isFullForm={false}
                            isEdit={true}
                            formData={noteData}
                            setFormData={setNoteData}
                          />
                        </Grid>
          
                       <Grid item xs={12} sm={6}>
                          <AssessmentTypeSelect
                            value={noteData.assessmentType || ''}
                            onChange={(value) =>
                              setNoteData((prev) => ({ 
                                ...prev, 
                                assessmentType: value 
                              }))
                            }
                          />
                        </Grid>
                        </Grid>
                        </Box>

              <Box sx={{ width: '100%', mt: 2 }}>
                <Paper elevation={1} sx={{ mb: 2, ml:2, mr:2, borderRadius: '0px' }}>
                  <Box sx={{ 
                    overflowX: 'auto',
                    '&::-webkit-scrollbar': {
                      height: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#c1c1c1',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#a8a8a8',
                    },
                  }}>
                    <Tabs 
                      value={activeTab} 
                      onChange={handleTabChange} 
                      aria-label="nurses assessment tabs"
                      variant={isMobile ? "scrollable" : "fullWidth"}
                      scrollButtons={false}
                      allowScrollButtonsMobile={false}
                      sx={{
                        '& .MuiTab-root': {
                          minHeight: '48px',
                          fontSize: '14px',
                          fontWeight: 500,
                          textTransform: 'none',
                          ...(isMobile && {
                            minWidth: 'auto',
                            padding: '12px 16px',
                            whiteSpace: 'nowrap',
                          }),
                          '@media (max-width: 600px)': {
                            fontSize: '12px',
                            padding: '8px 12px',
                            minHeight: '40px',
                          },
                        },
                        '& .Mui-selected': {
                          color: '#1976d2',
                        },
                        '& .MuiTabs-indicator': {
                          backgroundColor: '#1976d2',
                        }
                      }}
                    >
                      <Tab label="General Information" {...a11yProps(0)} />
                      <Tab label="Psychosocial & Medical" {...a11yProps(1)} />
                      <Tab label="Cardiovascular & Pulmonary" {...a11yProps(2)} />
                      <Tab label="GI, GU & Musculoskeletal" {...a11yProps(3)} />
                      <Tab label="Additional Information" {...a11yProps(4)} />
                    </Tabs>
                  </Box>
                </Paper>

                <TabPanel value={activeTab} index={0}>
                  <NursesAssessmentform1
                    data={form1Data}
                    setFormValues={setForm1Data}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                    isEdit={true}
                  />
                </TabPanel>

                <TabPanel value={activeTab} index={1}>
                  <NursesAssessmentForm2
                    data={form2Data}
                    setFormValues={setForm2Data}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                  />
                </TabPanel>

                <TabPanel value={activeTab} index={2}>
                  <NursesAssessmentForm3
                    data={form3Data}
                    setFormValues={setForm3Data}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                  />
                </TabPanel>

                <TabPanel value={activeTab} index={3}>
                  <NursesAssessmentForm4
                    data={form4Data}
                    setFormValues={setForm4Data}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                  />
                </TabPanel>

                <TabPanel value={activeTab} index={4}>
                  <DynamicForm
                    fields={formElements}
                    data={formData}
                    onSubmit={handleSubmitForm}
                    buttons={[]}
                    setFormValues={setFormData}
                  />
                </TabPanel>
              </Box>

              {/* Global Save and Cancel Buttons */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: { xs: 'stretch', sm: 'space-between' }, 
          gap: { xs: 2, sm: 2 }, 
          mt: 3, 
          p: { xs: 1, sm: 2 }
        }}>               
            
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 1.5, sm: 2 },
            flexDirection: { xs: 'column', sm: 'row' },
            order: { xs: 2, sm: 2 },
            mr: 1.5
          }}>
            <Button
              variant="contained"
              onClick={handleSaveAll}
              disabled={isFormLoading}
              fullWidth={isMobile}
              sx={{
                minHeight: { xs: '44px', sm: '32px' },
                fontSize: { xs: '14px', sm: '13px' },
                fontWeight: { xs: 500, sm: 400 },
                px: { xs: 2, sm: 1.5 }
              }}
            >
              {isFormLoading ? 'Saving...' : 'Save'}
            </Button>
            <Button
              variant="outlined"
              onClick={() => history.push('/notes/nurses-notes/list')}
              fullWidth={isMobile}
              sx={{
                minHeight: { xs: '44px', sm: '32px' },
                fontSize: { xs: '14px', sm: '13px' },
                fontWeight: { xs: 500, sm: 400 },
                px: { xs: 2, sm: 1.5 }
              }}
            >
              Cancel
            </Button>
          </Box>
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 1.5, sm: 2 },
            flexDirection: { xs: 'row', sm: 'row' },
            order: { xs: 1, sm: 1 },
            mr: 1.5
          }}>
            <Button
              variant="outlined"
              onClick={handlePrevious}
              disabled={activeTab === 0}
              sx={{
                minHeight: { xs: '44px', sm: '32px' },
                fontSize: { xs: '14px', sm: '13px' },
                fontWeight: { xs: 500, sm: 400 },
                px: { xs: 2, sm: 1.5 },
                flex: { xs: '1 1 50%', sm: '1 1 auto' }
              }}
            >
              Previous
            </Button>
            <Button
              variant="outlined"
              onClick={handleNext}
              disabled={activeTab === 4}
              sx={{
                minHeight: { xs: '44px', sm: '32px' },
                fontSize: { xs: '14px', sm: '13px' },
                fontWeight: { xs: 500, sm: 400 },
                px: { xs: 2, sm: 1.5 },
                flex: { xs: '1 1 50%', sm: '1 1 auto' }
              }}
            >
              Next
            </Button>
          </Box>
        </Box>
            </>
          )}
        </>
      }
    />
     <DescriptionModal
        open={isModalOpen}
        onClose={handleCloseModal}
        clientID={clientId}
        onSave={handleSaveDescription}
        section='NURSES_ASSESSMENT_SECTION'
      />
    </>
  )
}
